var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-item',{attrs:{"lineItem":_vm.addon,"actions":_vm.actions},scopedSlots:_vm._u([{key:"preffix",fn:function(){return [_c('i',{staticClass:"fas fa-chevron-left arrow-rotation text-slate text-xs pr-1 mr-1"})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }